import { Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PageHeading from '../../Components/PageHeading';
import CultService from '../../Services/CultService';
import toast from 'react-hot-toast';
import { HelperTexts } from '../../Utils/helper/HelperTexts';
import { useSelector } from 'react-redux';
import PageLoader from '../../Components/PageLoader';
import CallRecordingsList from './Components/CallRecordingsAlertList';
import RecordingsFilter from './Components/RecordingsFilter';
import { App, DatePicker, Select } from 'antd';
import moment from 'moment';
import CampaignEmptyState from '../../Components/CampaignEmptyState';
import SelectCampaign from '../../Components/SelectCampaign';
import { DotIcon } from '../../Components/Icons/Icons';
import { AppColors } from '../../Utils/helper/AppColors';

const { RangePicker } = DatePicker;

export default function AlertCall() {
	const company = useSelector((state) => state?.app?.company);
	const [loading, setLoading] = useState(false);
	// const [filterQuery, setFilterQuery] = useState(null);
	const [recordings, setRecordings] = useState([]);
	// const [campaigns, setCampaigns] = useState([]);
	// const [dateFilter, setDateFilter] = useState(null);
	const [pagination, setPagination] = useState({ count: 0, rowsPerPage: 10, page: 1 });
	const [value, setValue] = React.useState(0);

	const getRecordings = async (page = 1, limit = pagination?.rowsPerPage) => {
		setLoading(true);
		setRecordings([]);

		try {
			let res = await CultService.getCallRecordingsSuicidalTendency({
				params: {
					// companyId: company?._id,
					// users: filterQuery?.users?.map((i) => i._id),
					// campaigns: filterQuery?.campaigns?.map((i) => i._id),
					page: page,
					limit: limit,
				},
			});
			setRecordings(res?.data?.data?.recordings);

			console.log();

			if (res?.data?.data?.recordings?.length) {
				setPagination({
					count: res?.data?.data?.totalRecords,
					rowsPerPage: limit,
					page: res?.data?.data?.currentPage,
				});
			}
		} catch (err) {
			toast.error(HelperTexts?.SOMETHING_WENT_WRONG);
		} finally {
			setLoading(false);
		}
	};

	const getRecordingsHarassment = async (page = 1, limit = pagination?.rowsPerPage) => {
		setLoading(true);
		setRecordings([]);

		try {
			let res = await CultService.getCallRecordingsHarassmentTendency({
				params: {
					// companyId: company?._id,
					// users: filterQuery?.users?.map((i) => i._id),
					// campaigns: filterQuery?.campaigns?.map((i) => i._id),
					page: page,
					limit: limit,
				},
			});
			setRecordings(res?.data?.data?.recordings);

			console.log();

			if (res?.data?.data?.recordings?.length) {
				setPagination({
					count: res?.data?.data?.totalRecords,
					rowsPerPage: limit,
					page: res?.data?.data?.currentPage,
				});
			}
		} catch (err) {
			toast.error(HelperTexts?.SOMETHING_WENT_WRONG);
		} finally {
			setLoading(false);
		}
	};

	// const handleSelectCampaign = (i, option) => {
	// 	setFilterQuery((prev) => ({ ...prev, campaigns: [option?.item] }));
	// };

	// const getCampaings = async () => {
	// 	try {
	// 		let res = await CultService.getCampaignList({ params: { companyId: company?._id } });
	// 		if (res.status == 200) {
	// 			setCampaigns(res?.data);
	// 		}
	// 	} catch (err) {
	// 		toast.error(HelperTexts.SOMETHING_WENT_WRONG);
	// 	} finally {
	// 	}
	// };

	// const handleChange = (e, date) => {
	// 	if (!e) {
	// 		return setDateFilter(null);
	// 	}
	// 	let startDate = moment(new Date(e[0])).format();
	// 	let endDate = moment(new Date(e[1])).format();
	// 	setDateFilter({ ...dateFilter, startDate, endDate });
	// };

	const filterArrayByDate = (array, dateFilter) => {
		if (!dateFilter || !dateFilter.startDate || !dateFilter.endDate) {
			return array;
		}
		const { startDate, endDate } = dateFilter;
		return array?.filter((item) => {
			const itemDate = new Date(item.call.createdAt);
			const start = new Date(startDate);
			const end = new Date(endDate);
			return itemDate >= start && itemDate <= end;
		});
	};

	useEffect(() => {
		if (company) {
			value === 0 && getRecordingsHarassment();
			value === 1 && getRecordings();

			// getCampaings();
			// if (filterQuery?.campaigns?.length > 0) {
			// }
		}
	}, [company, value]);

	// const getScoreColor = (score) => {
	// 	let res = AppColors.STATUS_GREY;
	// 	if (score < 50) {
	// 		res = AppColors.STATUS_RED;
	// 	}
	// 	if (score >= 40 && score <= 70) {
	// 		res = AppColors.STATUS_YELLOW;
	// 	}
	// 	if (score > 70) {
	// 		res = AppColors.STATUS_GREEN;
	// 	}
	// 	return res;
	// };

	const tabs = [
		{
			code: 'Urgent Alert',
			Component: null,
			props: {},
		},
		{
			code: 'immediate Attention',
			Component: null,
			props: {},
		},
	];

	const handleChangeTab = (event, newValue) => {
		if (newValue !== null) {
			setValue(newValue);
		}
	};


	return (
		<Stack sx={{ padding: 2  }}  >
			{loading && <PageLoader />}
			<PageHeading title="Vulnerability Alert" subTitle="Listen to and manage alert conversations" />

			<Stack mt={'20px'}>
				{/* <ToggleButtonGroup size="small" color="primary" value={value} exclusive onChange={handleChangeTab}>
				{tabs?.map((tab, index) => (
					<ToggleButton
						key={index}
						sx={{ textTransform: 'none', px: 2, borderRadius: '8px', alignItems: 'center' }}
						value={index}
					>
						<Typography variant="subtitle2" fontSize={13} fontWeight={500}>
							{tab?.code}
						</Typography>
					</ToggleButton>
				))}
			</ToggleButtonGroup> */}
				{/* <Stack direction="row" gap={2}>
					<SelectCampaign handleSelectCampaign={handleSelectCampaign} />
					<RecordingsFilter campaigns={campaigns} setFilterQuery={setFilterQuery} />

					<Stack direction="row" alignItems="center" gap={1} ml="auto">
						<Stack direction="row" alignItems="center" gap={1}>
							<DotIcon size={16} color={getScoreColor(30)} />
							<Typography variant="subtitle2" fontSize={12}>
								Urgent
							</Typography>
						</Stack>
						<Stack direction="row" alignItems="center" gap={1}>
							<DotIcon size={16} color={getScoreColor(50)} />
							<Typography variant="subtitle2" fontSize={12}>
								Needs Review
							</Typography>
						</Stack>
						<Stack direction="row" alignItems="center" gap={1}>
							<DotIcon size={16} color={getScoreColor(80)} />
							<Typography variant="subtitle2" fontSize={12}>
								Stable
							</Typography>
						</Stack>
					</Stack>
					<RangePicker onChange={handleChange} style={{ marginLeft: 'auto' }} />
				</Stack> */}
				<ToggleButtonGroup
					size="small"
					value={value}
					exclusive
					border={0}
					onChange={handleChangeTab}
					sx={{ width: '100%', height: '100%' , border: `1px solid #D8CFF9` , borderRadius : '14px 14px 0 0' ,borderBottom : 0   }}
				>
					{tabs?.map((tab, index) => (
						<ToggleButton
							key={index}
							sx={theme=> ({
								textTransform: 'none',
								px: 2,
								alignItems: 'center',
								width: '50%',
								height: '100%',
								border: 0,
								borderRadius: '14px 14px 0 0',
								border : `1px solid ${AppColors?.lightest_grey || theme.palette.primary.lighter_shade}`,
								backgroundColor: theme.palette.secondary.lightest_grey || AppColors.NEW_BACKGROUND4,
								'&.Mui-selected': {
										backgroundColor: theme.palette.secondary.orange || theme.palette.primary.lightest_shade,
										color: theme.palette.secondary.orange || theme.palette.primary.darker_primary,
										'&:hover': { backgroundColor: theme.palette.secondary.orange || theme.palette.primary.lightest_shade },
									},
								'&:hover': { opacity : 0.9 },
							})}
							value={index}
						>
							<Typography fontSize={14} fontWeight={600} lineHeigh lineHeight={'150%'} 
							sx={(theme) =>
										value === index ? { color: theme.palette.primary.white } : { color: theme.palette.secondary.orange }
									}
							>
								{tab?.code}
							</Typography>
						</ToggleButton>
					))}
				</ToggleButtonGroup>
				{value === 0 ? (
					<CallRecordingsList
						fetch={getRecordingsHarassment}
						height="calc(100vh - 150px)"
						recordings={filterArrayByDate(recordings, '')}
						pagination={pagination}
						tabs={tabs} // Pass tabs here
						value={value} // Pass selected tab value
						handleChangeTab={handleChangeTab}
					/>
				) : (
					<CallRecordingsList
						fetch={getRecordings}
						height="calc(100vh - 150px)"
						recordings={filterArrayByDate(recordings, '')}
						pagination={pagination}
						tabs={tabs} // Pass tabs here
						value={value} // Pass selected tab value
						handleChangeTab={handleChangeTab}
					/>
				)}
			</Stack>
		</Stack>
	);
}
